var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 67.733332 67.733335",
    id: "svg2608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.997,
      fill: "#7293a0",
      strokeWidth: 0.319652,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.421053,
      paintOrder: "fill markers stroke"
    },
    id: "path2610",
    cx: 33.958672,
    cy: 33.691406,
    r: 33.742779
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2616",
    style: {
      opacity: 0.997,
      fill: "#ffffff",
      strokeWidth: 0.147494,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.421053,
      paintOrder: "fill markers stroke"
    },
    d: "m 127.14572,26.326348 a 16.426266,16.426266 0 0 0 -16.40882,16.426388 16.426266,16.426266 0 0 0 16.42639,16.426386 16.426266,16.426266 0 0 0 16.42587,-16.426386 16.426266,16.426266 0 0 0 -16.42587,-16.426388 16.426266,16.426266 0 0 0 -0.0176,0 z m 0.0176,1.39268 A 15.033911,15.033911 0 0 1 142.197,42.752736 15.033911,15.033911 0 0 1 127.16329,57.786961 15.033911,15.033911 0 0 1 112.12906,42.752736 15.033911,15.033911 0 0 1 127.16329,27.719028 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2616-8",
    style: {
      opacity: 0.997,
      fill: "#ffffff",
      strokeWidth: 0.130666,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.421053,
      paintOrder: "fill markers stroke"
    },
    d: "M 33.943335,19.139325 A 14.552204,14.551975 0 0 0 19.406587,33.691408 14.552204,14.551975 0 0 0 33.958901,48.24349 14.552204,14.551975 0 0 0 48.510757,33.691408 14.552204,14.551975 0 0 0 33.958901,19.139325 a 14.552204,14.551975 0 0 0 -0.01559,0 z m 0.01559,1.23377 A 13.318702,13.318492 0 0 1 47.277427,33.691408 13.318702,13.318492 0 0 1 33.958901,47.010179 13.318702,13.318492 0 0 1 20.639917,33.691408 13.318702,13.318492 0 0 1 33.958901,20.373095 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2616-8-2",
    style: {
      opacity: 0.997,
      fill: "#ffffff",
      strokeWidth: 0.166301,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.421053,
      paintOrder: "fill markers stroke"
    },
    d: "M 33.939146,15.170576 A 18.520985,18.520695 0 0 0 15.437838,33.691408 18.520985,18.520695 0 0 0 33.958964,52.21224 18.520985,18.520695 0 0 0 52.479505,33.691408 18.520985,18.520695 0 0 0 33.958964,15.170576 a 18.520985,18.520695 0 0 0 -0.01985,0 z m 0.01985,1.570254 A 16.951073,16.950808 0 0 1 50.909808,33.691408 16.951073,16.950808 0 0 1 33.958968,50.642572 16.951073,16.950808 0 0 1 17.007535,33.691408 16.951073,16.950808 0 0 1 33.958968,16.74083 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2616-8-0",
    style: {
      opacity: 0.997,
      fill: "#ffffff",
      strokeWidth: 0.201938,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.421053,
      paintOrder: "fill markers stroke"
    },
    d: "M 33.934964,11.201826 A 22.489767,22.489417 0 0 0 11.469088,33.691408 22.489767,22.489417 0 0 0 33.959029,56.18099 22.489767,22.489417 0 0 0 56.448255,33.691408 22.489767,22.489417 0 0 0 33.959029,11.201826 a 22.489767,22.489417 0 0 0 -0.02411,0 z m 0.02411,1.906737 A 20.583446,20.583124 0 0 1 54.5422,33.691408 20.583446,20.583124 0 0 1 33.959039,54.274965 20.583446,20.583124 0 0 1 13.375152,33.691408 20.583446,20.583124 0 0 1 33.959039,13.108563 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2623",
    style: {
      opacity: 0.997,
      fill: "#7293a0",
      fillOpacity: 1,
      strokeWidth: 0.345928,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.421053,
      paintOrder: "fill markers stroke"
    },
    d: "M 45.663057,27.899607 V 39.483205 H 61.53488 v -0.07657 a 1.2242644,5.7918006 0 0 0 0.197414,0.07657 1.2242644,5.7918006 0 0 0 1.224264,-5.791803 1.2242644,5.7918006 0 0 0 -1.224264,-5.791795 1.2242644,5.7918006 0 0 0 -0.197414,0.07657 v -0.07657 z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.997,
      fill: "#ffffff",
      strokeWidth: 0.239473,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.421053,
      paintOrder: "fill markers stroke"
    },
    id: "path2621",
    cx: 33.958672,
    cy: 33.691406,
    r: 10.583333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8d621a0e55f824df588f83f9a58dd76d.svg";
export { ForwardRef as ReactComponent };